import { useEffect, useState } from 'react'
import { todayLocal } from './plannerLogic'

function msUntilNextLocalMidnight() {
    const now = new Date()
    const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    return tomorrow.getTime() - now.getTime()
}

export function useLocalToday() {
    const [today, setToday] = useState(() => todayLocal())

    useEffect(() => {
        let timer = null

        const schedule = () => {
            if (timer) clearTimeout(timer)
            timer = setTimeout(update, msUntilNextLocalMidnight())
        }
        const update = () => {
            setToday(todayLocal())
            schedule()
        }
        const onVisibility = () => {
            if (document.visibilityState === 'visible') update()
        }
        const onFocus = () => update()

        schedule()
        document.addEventListener('visibilitychange', onVisibility)
        window.addEventListener('focus', onFocus)
        return () => {
            if (timer) clearTimeout(timer)
            document.removeEventListener('visibilitychange', onVisibility)
            window.removeEventListener('focus', onFocus)
        }
    }, [])

    return today
}